"use client";

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider, UIProvider } from "@xefi/x-react/providers";
import type { ReactNode } from "react";
import "../../dayjs.config";
import "@/i18n";
import { ToastContainer } from "@/components/shared/ToastContainer";
import { QueryProvider } from "./QueryProvider";
export const Providers = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ToastContainer />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <QueryProvider><UIProvider locale="fr"><ThemeProvider forcedTheme="light" disableTransitionOnChange={true}>{t1}{children}</ThemeProvider></UIProvider></QueryProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};